import moment from 'moment';
import {
    Button,
    Col,
    Row,
    Space,
    Table,
    Tooltip,
    Typography,
} from 'antd';
import {
    FC,
    useContext,
    useEffect,
    useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { TbTestPipe } from 'react-icons/tb';
import { MdDelete } from 'react-icons/md';

import ConceptEvalModal from '../../Modals/ConceptEvalModal';
import { IConcept, IConceptCondition } from '../../../interfaces/plan';
import { MRRConceptsContext } from '../context/MRRConceptsContext';
import { MRRConceptModal } from '../../Modals/MRRConceptModal';

const { Text } = Typography;

const MrrConcepts: FC = () => {
    const [concept, setConcept] = useState<IConcept>();
    const [showConcept, setShowConcept] = useState(false);
    const [testConcept, setTestConcept] = useState(false);
    const { id } = useParams();

    const {
        concepts,
        loading,
        addConcept,
        fetchConcepts,
        removeConcept,
    } = useContext(MRRConceptsContext);

    useEffect(() => {
        fetchConcepts();
    }, []);

    const handleTestConcept = (conceptId: string) => {
        setConcept(concepts.find((c: any) => c._id === conceptId));
        setTestConcept(true);
    };

    const handleDeleteConcept = (conceptId: string) => {
        removeConcept(id!, conceptId);
    };

    const menu = (conceptId: string) => (
        <Row justify="center" gutter={12}>
            {/* <Col>
                <Tooltip title="Test">
                    <Button
                        icon={<TbTestPipe style={{ verticalAlign: 'middle', color: '#177DDC' }} />}
                        type="ghost"
                        onClick={() => handleTestConcept(conceptId)}
                    />
                </Tooltip>
            </Col> */}
            <Col>
                <Tooltip title="Delete">
                    <Button
                        icon={<MdDelete style={{ verticalAlign: 'middle', color: '#FF426F' }} />}
                        type="ghost"
                        onClick={() => handleDeleteConcept(conceptId)}
                    />
                </Tooltip>
            </Col>
        </Row>
    );

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            render: (name: string, concept: any) => (
                <a
                    style={{ color: '#177DDC' }}
                    onClick={() => {
                        setConcept({ ...concept });
                        setShowConcept(true);
                    }}
                >
                    {name}
                </a>
            ),
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 150,
            render: (createdAt: string) => (
                <Text>
                    {moment(createdAt).format('MMM DD MMM')}
                </Text>
            ),
        },
        {
            title: 'Frequency',
            dataIndex: 'frequency',
            key: 'frequency',
            width: 150,
            render: (frequency: string) => (
                <Text>
                    {frequency || 'Not available'}
                </Text>
            ),
        },
        {
            title: (
                <Space>
                    <Text style={{ color: '#FFF' }}>Conditions | </Text>
                    <Text style={{ color: '#e5a500' }}>Field</Text>
                    <Text style={{ color: '#FFF' }}>Operator</Text>
                    <Text style={{ color: '#6C8EEF' }}>Value</Text>
                </Space>
            ),
            dataIndex: 'conditions',
            key: 'conditions',
            width: 600,
            render: (conditions: IConceptCondition[]) => (
                conditions.map((condition, index) => (
                    <div style={{ display: 'flex', gap: 12 }}>
                        <Text style={{ color: '#e5a500' }}>
                            {condition.field}
                        </Text>
                        <Text style={{ color: '#FFF' }}>
                            {condition.operator}
                        </Text>
                        <Text style={{ color: '#6C8EEF' }}>
                            {condition.value}
                        </Text>
                    </div>

                ))
            ),
        },
        {
            title: 'Operation',
            dataIndex: 'operation',
            key: 'operation',
            render: (operation: string) => (
                <Tooltip title={operation}>
                    <span
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: 180,
                            display: 'inline-block',
                        }}
                    >
                        {operation || 'Not available'}
                    </span>
                </Tooltip>
            ),
        },
        {
            title: 'Actions',
            dataIndex: '_id',
            key: 'actions',
            fixed: 'right' as 'right',
            with: 60,
            render: (_id: string) => (menu(_id)),
        },
    ];

    const handleAddConcept = () => {
        setShowConcept(true);
        setConcept({
            _id: '', name: '', operation: '', conditions: [] as IConceptCondition[], planID: id as string,
        });
    };

    const handleCancelConcept = (concept: any) => {
        if (concept) {
            addConcept(concept);
        }
        setShowConcept(false);
    };

    return (
        <div style={{ padding: '32px 0' }}>
            <Space direction="vertical" size={24} style={{ width: '100%' }}>
                <Row justify="end" gutter={[0, 20]}>
                    {
                        showConcept && (
                            <MRRConceptModal
                                visible={showConcept}
                                concept={concept}
                                onCancel={handleCancelConcept}
                            />
                        )
                    }
                    {
                        testConcept && (
                            <ConceptEvalModal
                                visible={!!testConcept}
                                concept={concept as IConcept}
                                onCancel={() => setTestConcept(false)}
                            />
                        )
                    }
                    <Button type="primary" onClick={handleAddConcept}>
                        Add Concept
                    </Button>
                </Row>
                <Table
                    columns={columns}
                    dataSource={concepts}
                    loading={loading}
                    pagination={false}
                    rowKey="_id"
                    locale={{ emptyText: 'No concepts' }}
                    scroll={{ x: 1200 }}
                    size="small"
                />
            </Space>
        </div>
    );
};

export { MrrConcepts };
